'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useImageAssetsUrl } from '@marketplace-web/shared/assets'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  icon: string
  title: string
  body: string
}

const FactBlock = ({ icon, title, body }: Props) => {
  const assetUrl = useImageAssetsUrl()

  return (
    <section className="page-section__fact-block">
      <div className="page-section__fact-icon">
        <Image src={assetUrl(`images/safety/${icon}.svg`)} size={Image.Size.Large} alt="" />
      </div>
      <ResponsiveWrapper
        mobile={<Spacer size={Spacer.Size.Large} />}
        desktop={<Spacer size={Spacer.Size.Large} orientation={Spacer.Orientation.Vertical} />}
      />
      <ResponsiveWrapper desktop={<Spacer orientation={Spacer.Orientation.Vertical} />} />
      <div className="page-section__content">
        <Text as="span" html>
          <div className="safety_fact-title">{title}</div>
        </Text>
        <ResponsiveWrapper mobile={<Spacer />} desktop={<Spacer size={Spacer.Size.Large} />} />
        <div className="safety_body">{body}</div>
      </div>
    </section>
  )
}

export default FactBlock
